export default __webpack_public_path__ + "static/media/fridge1-before2-2048w.dceff275.webp";